import axios from "axios";
import { URL_BASE } from "../../../constants/url";
import { get, post } from "../../../utils/fetch";

const base = `${URL_BASE}/api/EvaluacionCalidad`;

async function leerRespuesta(request) {
  const result = await request;
  if (result.code !== 0) {
    throw new Error(result.error);
  }
  return result.data;
}

export const getEmpleado = texto =>
  leerRespuesta(get(`${base}/GetEmpleado/${encodeURIComponent(texto)}`));

export const getAsistencia = texto =>
  leerRespuesta(get(`${base}/GetAsistencia/${encodeURIComponent(texto)}`));

export const getEvaluacionesEmpleado = () =>
  leerRespuesta(get(`${base}/GetEvaluacionesEmpleado`));

export const buscarAsistenciaID = asistenciaID =>
  leerRespuesta(get(`${base}/BuscarAsistenciaID/${encodeURIComponent(asistenciaID)}`));

export const getListaPlantillas = () =>
  leerRespuesta(get(`${base}/GetListaPlantillas`));

export const getListaSupervisores = () =>
  leerRespuesta(get(`${base}/GetListaSupervisores`));

export const getEvaluacionEmpleado = id =>
  leerRespuesta(
    get(`${base}/GetEvaluacionEmpleado/${encodeURIComponent(id)}`)
  );

export const getListaRubros = evaluacionID =>
  leerRespuesta(
    get(`${base}/GetListaRubros/${encodeURIComponent(evaluacionID)}`)
  );

export const nuevaEvaluacion = body =>
  leerRespuesta(post(`${base}/NuevaEvaluacion`, body));

export const actualizarFirmasEvaluacion = body =>
  leerRespuesta(post(`${base}/ActualizarFirmasEvaluacion`, body));

export async function descargarFirmaEvaluacion(evaluacionEmpleadoID, tipoFirma) {
  const { data } = await axios.post(
    `${base}/DescargaFirmasEvaluacion`,
    { evaluacionEmpleadoID, tipoFirma },
    { responseType: "blob" }
  );
  return data;
}
